import { DrawingLayer } from 'business/models/DrawingLayer';
import { RandomLayerDTO, RandomLayerGroupIngredientDTO } from 'business/models/Models';
import { isNullOrUndefined } from 'utils/Global';
import { getIngIngType } from '../Generate/GenerateCommon';
import RandomLayerIngredientGroup from './RandomLayerIngredientGroup';

export default class RandomLayerGroupIngredient {
  public static CanPlatesBeGenerated(lyr: DrawingLayer) {
    const rlgiRows: RandomLayerGroupIngredientDTO[] =
      this.GetRandomLayerGroupIngredientRows(lyr);
    if (rlgiRows.length == 0) {
      return false;
    }

    for (const rlgiRow of rlgiRows) {
      if (isNullOrUndefined(getIngIngType(rlgiRow.ingredientIngredientTypeId))) {
        return false;
      }
    }

    let totalWeight = 0; // Compute sum of the weights of all ingredients in group
    for (const rlgiRow of rlgiRows) {
      totalWeight += rlgiRow.weight;
    }
    if (totalWeight == 0) {
      return false;
    }

    return true;
  }
  public static GetRandomLayerGroupIngredientRows(lyr: DrawingLayer) {
    const groupIDs: number[] =
      RandomLayerIngredientGroup.GetUsedGroupIDsByRandomLayerID(lyr);

    const rlgiRows: RandomLayerGroupIngredientDTO[] = [];
    (lyr.layerDetail as RandomLayerDTO).randomLayerIngredientGroup.map((rlig) => {
      if (groupIDs.includes(rlig.id)) {
        rlig.randomLayerGroupIngredient.map((rlgi) => {
          rlgiRows.push(rlgi);
        });
      }
    });
    return rlgiRows;
  }
}
